export default "/images/slickslide-2.jpg?3875b0d851022638aaf120b1833d8a33";